import React from "react";
import styled, { keyframes } from "styled-components";

interface Props {
  size?: string;
  color?: string;
}

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

export const Spinner = styled.div.attrs({
  role: "status",
})<Props>`
  display: inline-block;
  vertical-align: text-bottom;

  width: ${({ size }) => size || "2rem"};
  height: ${({ size }) => size || "2rem"};

  border-width: 5px;
  border-style: solid;
  border-color: ${({ color }) => color || "#cf0010"};
  border-right-color: transparent;
  border-radius: 50%;

  animation: ${rotate} 700ms linear infinite;
`;

export const Loader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100vw;
  height: 100vh;
`;

export default (props: Props) => {
  return (
    <Loader>
      <Spinner {...props} />
    </Loader>
  );
};
